import * as FileActions from '../../actions/files';
import { reducer } from '../reducerUtils';

const initialState = {
  fileMaps: {},
  error: '',
  docrioFiles: [],
  selectedFiles: {},
  currentFileId: '',
  filesSaveJobIds: [],
  savedFileCount: undefined,
  navigatingDocrioFiles: false,
  loadingDocrioFiles: false,
  skeletonFiles: 0,
  disableAddSaveLocation: true,
  saveLocationAdded: false,
  fileValidationErrors: {},
  fileValidationPending: false,
};

export default reducer({
  [FileActions.SET_FILE_MAPS]: (state, { payload: { fileMaps } }) => ({
    ...state,
    fileMaps,
  }),
  [FileActions.CLEAR_FILE_MAPS]: (state, action) => ({
    ...state,
    fileMaps: {}, // do we need this
    filesToSave: [], // do we need this
    docrioFiles: state.docrioFiles.map((file) => {
      if (action.selectedRecordId) {
        delete file.folderPaths[action.selectedRecordId];
        return file;
      } else {
        return {
          contentType: file.contentType || undefined,
          hash: file.hash,
          id: file.id,
          name: file.outlookName || file.name,
        };
      }
    }),
  }),
  [FileActions.POST_FILES_FAILURE]: (state, action) => ({
    ...state,
    error: action.payload.error,
  }),
  [FileActions.UPLOAD_FILES_FAILURE]: (state, action) => ({
    ...state,
    error: action.payload.error,
  }),
  [FileActions.COMPLETE_FILES_SUCCESS]: (state, action) => ({
    ...state,
    docrioFiles: action.files,
  }),
  [FileActions.COMPLETE_FILES_FAILURE]: (state, action) => ({
    ...state,
    error: action.payload.error,
  }),
  [FileActions.SET_SELECTED_FILES]: (state, action) => ({
    ...state,
    selectedFiles: action.selectedFiles,
  }),
  [FileActions.SET_DOCRIO_FILES]: (state, action) => ({
    ...state,
    docrioFiles: [...action.files],
  }),
  [FileActions.GET_DOCRIO_FILES]: (state) => {
    return {
      ...state,
      docrioFiles: state.docrioFiles,
    };
  },
  [FileActions.SET_FILE_SAVE_STATE]: (state, action) => ({
    ...state,
    docrioFiles: state.docrioFiles.map((file) => {
      if (file.id === action.file.itemId) {
        return { ...file, saved: action.status ? false : file.saved, toSave: action.status, presaved: action.status ? false : file.presaved, folderPaths: action.file.folderPaths };
      } else {
        return file;
      }
    }),
  }),
  [FileActions.SET_CURRENT_FILE_ID]: (state, action) => ({
    ...state,
    currentFileId: action.fileId,
  }),
  [FileActions.SET_FILES_SAVE_JOBS]: (state, action) => ({
    ...state,
    filesSaveJobIds: [...state.filesSaveJobIds, ...action.jobIds],
  }),
  [FileActions.CLEAR_FILE_SAVE_JOBS]: (state, action) => ({
    ...state,
    filesSaveJobIds: [],
  }),
  [FileActions.SET_SAVED_FILE_COUNT]: (state, action) => ({
    ...state,
    savedFileCount: action.savedFileCount,
  }),
  [FileActions.NAVIGATING_DOCRIO_FILES]: (state, action) => ({
    ...state,
    navigatingDocrioFiles: action.payload,
  }),
  [FileActions.LOADING_DOCRIO_FILES]: (state, action) => ({
    ...state,
    loadingDocrioFiles: action.payload,
  }),
  [FileActions.SET_SKELETON_FILES]: (state, action) => ({
    ...state,
    skeletonFiles: action.skeletonCount,
  }),
  [FileActions.SET_ATTACHED_FILES]: (state, action) => ({
    ...state,
    attachedFiles: action.attachedFiles,
  }),
  [FileActions.REMOVE_FILE_MAP]: (state, action) => ({
    ...state,
    fileMaps: removeFileMap(state, action),
  }),
  [FileActions.DISABLE_ADD_SAVE_LOCATION]: (state, action) => ({
    ...state,
    disableAddSaveLocation: action.payload,
  }),
  // docrioFiles[i].folderPaths is now a nested object { <recordId>: 'folderPaths', <recordId>: 'folderPaths', ... }
  [FileActions.REMOVE_FOLDER_PATH]: (state, { recordId }) => ({
    ...state,
    docrioFiles: state.docrioFiles.map((file) => {
      delete file.folderPaths[recordId];
      return file;
    }),
  }),
  [FileActions.SAVE_LOCATION_ADDED]: (state, action) => ({
    ...state,
    saveLocationAdded: action.payload,
  }),
  [FileActions.SET_FILE_VALIDATION_ERRORS]: (state, action) => ({
    ...state,
    fileValidationErrors: { ...action.errorsByFileId },
  }),
  [FileActions.SET_FILE_VALIDATION_PENDING]: (state, action) => ({
    ...state,
    fileValidationPending: action.pending,
  }),
}, initialState);

const removeFileMap = (state, { recordId }) => {
  const updatedFileMap = { ...state.fileMap };
  delete updatedFileMap[recordId];
  return updatedFileMap;
};
